/**
 * Environment Variables Configuration
 * Validon dhe eksporton environment variables
 */

const requiredEnvVars = ["REACT_APP_API_URL"];

const env = {
  API_URL: process.env.REACT_APP_API_URL,
  API_URL_Image:
    process.env.REACT_APP_API_URL_Image || process.env.REACT_APP_API_URL,
  // Database connection info (për display/monitoring)
  DB_HOST: process.env.REACT_APP_DB_HOST || "",
  DB_NAME: process.env.REACT_APP_DB_NAME || "",
  DB_PORT: process.env.REACT_APP_DB_PORT || "",
};

// Eksporto si named export dhe default
export const API_URL = env.API_URL;
export const API_URL_Image = env.API_URL_Image;

// Validimi i environment variables
const missingVars = requiredEnvVars.filter((varName) => {
  const value = process.env[varName];
  return !value || (typeof value === "string" && value.trim() === "");
});

if (missingVars.length > 0) {
  const errorMessage = `Missing required environment variables: ${missingVars.join(
    ", "
  )}`;
  console.error(errorMessage);

  // Në development, shfaq një warning
  if (process.env.NODE_ENV === "development") {
    console.warn("Warning: " + errorMessage);
    console.warn(
      "Sigurohu që .env file ekziston dhe ka REACT_APP_API_URL të vendosur."
    );
  } else {
    // Në production, throw error
    throw new Error(errorMessage);
  }
}

// Validimi i vlerës së API_URL
if (
  !env.API_URL ||
  (typeof env.API_URL === "string" && env.API_URL.trim() === "")
) {
  const errorMessage =
    "API_URL nuk është i konfiguruar ose është i zbrazët. Kontrollo .env file.";
  console.error(errorMessage);
  if (process.env.NODE_ENV === "development") {
    console.warn("Warning: " + errorMessage);
  } else {
    throw new Error(errorMessage);
  }
}

export default env;
